<div class="admin-content">
  <h1 class="cei-portal-pagina__titulo">Olá, {{ userLogin() || 'Acessante' }}!</h1>
  <p class="cei-portal-pagina__subtitulo">Bem-vindo ao painel administrativo CEI.</p>
</div>
